import React, { useState, useEffect, useCallback } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import { debounce } from "@mui/material";
import { Link, useNavigate } from "react-router-dom";
import { DataGrid } from "@mui/x-data-grid";
import SearchOutlinedIcon from "@mui/icons-material/SearchOutlined";
import RemoveRedEyeOutlinedIcon from "@mui/icons-material/RemoveRedEyeOutlined";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import { usePermissions } from "../../../../context/permissionContext";
import { validatePermission } from "../../../../utils/permissionUtils";
import { getDealFlowColumns } from "../../../../utils/dealFlowColumns";
import { getErrorMessage } from "../../../../utils/errorUtils";
import Loader from "../../../../components/Loader/Loader";
import "../../../../components/common/css/datatable.scss";

const CompletedCamp = () => {
  const [searchTerm, setSearchTerm] = useState("");
  const [loading, setLoading] = useState(false);
  const { permissions, permissionsMapping } = usePermissions();
  const navigate = useNavigate();
  const [pageState, setPageState] = useState({
    data: [],
    total: 0,
    page: 1,
    pageSize: 10,
  });

  const fetchuserCampaignData = () => {
    const token = localStorage.getItem("accessToken");
    setLoading(true);
    setPageState((old) => ({ ...old }));
    var config = {
      method: "post",
      url: process.env.REACT_APP_API + "get-campaign-list-admin",
      headers: {
        "x-access-token": token,
      },
      data: {
        status: 1,
        campaign_status: 4,
        is_deleted: 0,
        page: pageState.page,
        limit: pageState.pageSize,
        searchTerm: searchTerm,
        isForAdminReview: 0,
      },
    };

    axios(config)
      .then(function (response) {
        setPageState((old) => ({
          ...old,
          data: response.data.data.rows,
          total: response.data.data.count,
        }));
        setLoading(false);
      })
      .catch(function (error) {
        setLoading(false);
        const errorMessage = getErrorMessage(
          error,
          "Failed to load completed campaigns"
        );
        Swal.fire({
          title: "Error",
          timer: 2500,
          timerProgressBar: true,
          text: errorMessage,
          icon: "error",
          confirmButtonColor: "#f27474",
          confirmButtonText: "OK",
          dangerMode: true,
          showCloseButton: true,
        });
      });
  };

  const handleQuery = useCallback(
    debounce((e) => {
      setSearchTerm(e.target.value);
      setPageState({ ...pageState, page: 1 });
    }, 1000)
  );

  useEffect(() => {
    fetchuserCampaignData();
  }, [pageState.page, pageState.pageSize, searchTerm]);

  // useEffect(() => {}, [completed]);

  const actionColumn = [
    {
      field: "action",
      headerName: "Action",
      width: 200,
      renderCell: (params) => {
        const hasDeletePermission = validatePermission(
          "Campaign - Completed:Delete",
          permissions,
          permissionsMapping
        );
        return (
          <div className="cellAction">
            <Link
              to={`/completed-campaign/${params.row.id} `}
              style={{ textDecoration: "none" }}
            >
              <div className="viewButton">
                <RemoveRedEyeOutlinedIcon />
              </div>
            </Link>
            {hasDeletePermission && (
              <div
                className="deleteButton"
                onClick={() => deleteFunction(params?.row?.id)}
              >
                <DeleteOutlineIcon />
              </div>
            )}
          </div>
        );
      },
    },
  ];

  const userColumns = [
    { field: "id", headerName: "ID", width: 70 },
    {
      field: "corporation_legal_name",
      headerName: "Campaign Name",
      width: 170,
    },
    {
      field: "city",
      headerName: "Location",
      width: 170,
    },
    {
      field: "craax_account",
      headerName: "CRA Tax Account",
      width: 170,
    },
    {
      field: "entitytype",
      headerName: "Entity Type",
      width: 170,
    },
    {
      field: "website",
      headerName: "Website",
      width: 170,
    },
    {
      field: "camp_email",
      headerName: "Email",
      width: 200,
    },
  ];
  const deleteFunction = (id) => {
    const token = localStorage.getItem("accessToken");
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      showCloseButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        setLoading(true);
        var config = {
          method: "patch",
          url: process.env.REACT_APP_API + "admin/delete-campaign",
          headers: {
            "x-access-token": token,
          },
          data: {
            campaign_id: id,
          },
        };
        axios(config)
          .then(function (res) {
            if (res.status == 200) {
              Swal.fire("Deleted!", "Your file has been deleted.", "success");
              navigate("/deleted-campaign");
              // fetchuserCampaignData();
              setLoading(false);
            }
          })
          .catch(function (error) {
            setLoading(false);
            console.log(error);
          });
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        setLoading(false);
        Swal.fire("Cancelled", "Your data is safe", "error");
      }
    });
  };
  return (
    <div className="datatable">
      <Loader isLoading={loading} />
      <div className="datatableTitle">
        <div className="tablesearch">
          <input type="text" placeholder="Search..." onChange={handleQuery} />
          <SearchOutlinedIcon className="sarchicon" />
        </div>
        <h5 style={{ marginLeft: "-10%" }}>Campaigns - Completed</h5>
        <div></div>
      </div>
      <DataGrid
        className="datagrid"
        autoHeight
        rows={pageState.data.filter((data) => {
          return Object.keys(data).some((key) =>
            data[key]
              ?.toString()
              .toLowerCase()
              .includes(searchTerm.toString().toLowerCase())
          );
        })}
        rowCount={pageState.total}
        rowsPerPageOptions={[10, 30, 50, 70, 100]}
        pagination
        page={pageState.page - 1}
        pageSize={pageState.pageSize}
        paginationMode="server"
        onPageChange={(newPage) => {
          setPageState((old) => ({ ...old, page: newPage + 1 }));
        }}
        onPageSizeChange={(newPageSize) =>
          setPageState((old) => ({ ...old, pageSize: newPageSize }))
        }
        columns={userColumns.concat(getDealFlowColumns(), actionColumn)}
      />
    </div>
  );
};

export default CompletedCamp;
